// React
import React from "react";

// Core
import { getHistory } from "../../Core/Utils/Utils";

// Material-UI (Core)
import { Box, Typography } from "@material-ui/core";

// Custom
import styled from "styled-components";

const StyledBlock = styled(Box)<{ disabled?: boolean }>`
    display: flex;
    transition: all 0.3s ease;
    gap: 0;
    position: relative;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${props => (props.disabled ? 0.5 : 1)};
`;

const IconContainer = styled(Box)`
    margin-top: 0;
    display: flex;
    align-items: center;
    align-items: center;
    height: 60px;
    width: 60px;
    justify-content: center;

    svg {
        height: 100% !important;
        width: 100% !important;
    }
`;

interface FooterBlockProps {
    icon?: any;
    title: string;
    path?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    height?: string;
    width?: string;
    disabled?: boolean;
    showIndicator?: boolean;
}

export const FooterMenuBlock: React.FC<FooterBlockProps> = props => {
    const gotoPageCommand = () => {
        if (props.disabled) {
            return; // Don't navigate if disabled
        }
        if (props.path) {
            getHistory().push(props.path);
        }
    };

    return (
        <StyledBlock id={"footerblock"} onClick={gotoPageCommand} style={props.style!} disabled={props.disabled}>
            <Box position={"relative"}>
                {props.icon && <props.icon width={props.width} height={props.height} />}
                {props.showIndicator && (
                    <Box
                        style={{
                            marginLeft: 8,
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "#3aaa35",
                            position: "absolute",
                            right: "0px",
                            top: "-4px",
                        }}
                    />
                )}

                <Box>
                    <Typography>{props.title}</Typography>
                </Box>
            </Box>
        </StyledBlock>
    );
};
